var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-container"},[_c('end_info'),(_vm.local_config.fields.phone != undefined || _vm.local_config.fields.email_optin != undefined)?_c('subscribe_form'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }